import { createSlotRecipe } from './runtime';

const alertConfig = {"name":"alert","slots":["root","icon","content","title","description","action"],"defaultVariants":{"tone":"info"},"variantMap":{"tone":["danger","info","success","warning"]}}

export const alert = /* @__PURE__ */ createSlotRecipe(alertConfig)